<template>
    <div>
        <Collapse v-model="value" simple style="border:0">
            <Panel name="1" hide-arrow style="margin: 20px 0;border:0" >
                <FormTitle :titleText="$t('Department_Level')"/><!-- 部门层级 -->
                <div slot="content" style="margin-top: 40px;">
                    <Table border :loading="loading" :columns="columns" :data="data"> </Table>
                    <div style="margin:20px 0;">
                        <Page style="float: right" :total="total" @on-change="pageChange"/>
                    </div>
                </div>
            </Panel>
            <div  v-if="id==''">
                <span style="color: red;">{{$t('EmpFilesComment')}}</span>
            </div> 
        </Collapse>
       
    </div>
</template>

<script>
import axios from 'axios'
import DateUtil from "@/util/DateUtil";
export default {
    data(){
        return{
            formItem:{},
            list:[],
            value:[1],
            date: new DateUtil(),
            loading:false,
            pageInfo: {
                itemCount: 0,
                pageNo: 1,
                pageSize: 10,
            },
            total: 0,
            data:[],
            id:''
        }
    },
    computed:{
        columns(){
            return [
                {
                    title: this.$t('Start_Date'),/* 开始日期 */
                    key: "moveDate",
                    align: "center",
                    minWidth: 120,
                    ellipsis:true,
                    render: (h, params) => {
                        return h(
                            "span",
                            this.date.dateVal(params.row.moveDate, "YYYY-MM-DD")
                        );
                    },
                },{
                    title: "Level1",
                    key: this.lang=='zh'?"orgName1":"orgEName1",
                    align: "center",
                    minWidth: 120,
                    ellipsis:true,
                    
                },{
                    title: "Level2",
                    key: this.lang=='zh'?"orgName2":"orgEName2",
                    align: "center",
                    minWidth: 120,
                    ellipsis:true,
                },{
                    title: "Level3",
                    key: this.lang=='zh'?"orgName3":"orgEName3",
                    align: "center",
                    minWidth: 120,
                    ellipsis:true,
                },{
                    title: "Level4",
                    key: this.lang=='zh'?"orgName4":"orgEName4",
                    align: "center",
                    minWidth: 120,
                    ellipsis:true,
                },
            ]
        },
        lang(){
            return this.$store.getters.selectLangeData
        }
    },
    methods:{
        getData(val){
            this.loading=true
            val?this.serialnumber=val:this.serialnumber=JSON.parse(sessionStorage.getItem("userInfo")).serialnumber
            axios.post("/employeeInformation/selectEmployeeDepartment", {...this.pageInfo,serialnumber:this.serialnumber}).then((res) => {
                this.loading=false
                if (res) {
                   this.data=res.data
                   this.total=parseInt(res.pageInfo.total)
                }
            })
        },
        pageChange(val){
            this.pageInfo.pageNo = val
        },
    }
}
</script>

<style lang="less" scoped>
.btnfooter {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/process/files/components/DepartmentLevel.vue